<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="100px">
        <div class="input-box">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">  
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div>
            <el-form-item label="月份：">
              <el-date-picker
                style="width:193px;"
                v-model="form.month"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:api,data:form,callback:_d => tableData = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('gyxrlzysczytjzbb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._w"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/人力资源市场主要统计指标表--导入.xls" download="人力资源市场主要统计指标表.xls">下载模板</a> -->
        下载模板
      </el-button>
      <el-button v-if="showBtn[5].isShow" type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="人力资源市场主要统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      width="1400px"
      :close-on-click-modal="false"
      @close="close"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">岗位信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="218px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="县区市：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="登记求职人数(人)：">
                          <el-input style="width:193px;" v-model="editForm.registerJobWanted"></el-input>
                        </el-form-item>
                        <el-form-item label="提供就业岗位(个)：">
                          <el-input style="width:193px;" v-model="editForm.openJob"></el-input>
                        </el-form-item>
                        <el-form-item label="失业人员职业指导人数(人)：">
                          <el-input style="width:193px;" v-model="editForm.lostJobHelp"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="介绍成功总人数人数(人)：">
                          <el-input style="width:193px;" v-model="editForm.introduceSuccess"></el-input>
                        </el-form-item>
                        <el-form-item label="失业人员介绍成功人数(人):">
                          <el-input style="width:193px;" v-model="editForm.introduceSuccessForLostJob"></el-input>
                        </el-form-item>
                        <el-form-item label="就业困难人员介绍成功人数(人)：">
                          <el-input style="width:193px;" v-model="editForm.introduceSuccessForDifficult"></el-input>
                        </el-form-item>
                        <el-form-item label="城镇登记失业人数(人)：">
                          <el-input style="width:193px;" v-model="editForm.lostJobPerson"></el-input>
                        </el-form-item>
                        <el-form-item label="城镇登记失业率(%)：">
                          <el-input style="width:193px;" v-model.number="editForm.lostJobPercent"></el-input>
                        </el-form-item>
                        <el-form-item label="月份：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.month"
                            value-format="yyyy-MM"
                            type="month"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/resourceMarket',
      form:{},
      type:'3',
      centerDialogVisible:false,
      tableData:[],
      selectRow:[],            
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'registerJobWanted',value:'登记求职人数(人)'},
        {key:'openJob',value:'提供就业岗位(个)'},
        {key:'lostJobHelp',value:'失业人员职业指导人数(人)'},
        {key:'introduceSuccess',value:'介绍成功总人数人数(人)'},
        {key:'introduceSuccessForLostJob',value:'失业人员介绍成功人数(人)'},
        {key:'introduceSuccessForDifficult',value:'就业困难人员介绍成功人数(人)'},
        {key:'lostJobPerson',value:'城镇登记失业人数(人)'},
        {key:'lostJobPercent',value:'城镇登记失业率(%)'},
        {key:'month',value:'月份'}
            ],
      rules:{
        socialCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
      },
      isCreate:false,
    }
  },
  created() {
    this.isShowBtn("ResourceMarket")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },

    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>